import {request} from "@/network/request";


export function getRNA_Proteins(){
    return request({
        url:'/api/show_rna_pro'
    })}
export function getRNAs_Proteins(){
    return request({
        url:'/api/show_rnas_pro'
    })}
export function getRNAs(){
    return request({
        url:'/api/show_rnas'
    })}

export function getvivo(){
    return request({
        url:'/api/show_vivo'
    })}

export function getvitro(){
    return request({
        url:'/api/show_vitro'
    })}




export function getpoly(){
    return request({
        url:'/api/show_poly'
    })}
export function getmrna(){
    return request({
        url:'/api/show_mRNAs'
    })}
export function getlncrna(){
    return request({
        url:'/api/show_lncRNAs'
    })}
export function getrrna(){
    return request({
        url:'/api/show_rRNAs'
    })}


export function getsnorna(){
    return request({
        url:'/api/show_snorna'
    })}
export function getpirna(){
    return request({
        url:'/api/show_pirna'
    })}



export function getsirna(){
    return request({
        url:'/api/show_siRNAs'
    })}
export function gettotalrna(){
    return request({
        url:'/api/show_totalrna'
    })}
export function getvirysrna(){
    return request({
        url:'/api/show_virysrna'
    })}
export function getmirna(){
    return request({
        url:'/api/show_mirna'
    })}

export function getsnrna(){
    return request({
        url:'/api/show_snrna'
    })}


export function getfr(){
    return request({
        url:'/api/show_frrna'
    })}
export function getir(){
    return request({
        url:'/api/show_irrna'
    })}
export function getnr(){
    return request({
        url:'/api/show_nrrna'
    })}

